export default "__VITE_ASSET__d268afea__"